import { Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { FormlyFieldConfig, FormlyFormOptions } from "@ngx-formly/core";
import { ConfirmationService, FilterMatchMode, MessageService, SelectItem } from "primeng/api";
import { Table } from "primeng/table";
import { ApiService } from "src/app/_services/api.service";
import { GlobalService } from "src/app/_services/global.service";
import { FilterService } from 'primeng/api';
import { LanguageService } from "src/app/_services/language.service";

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
  providers: [FilterService,MessageService, ConfirmationService],
  encapsulation: ViewEncapsulation.None
  
})
export class TableComponent implements OnInit {
  @Input() public pageTitle: string ='';
  @Input() public newRecordUrl: string ='';
  @Input() public editRecordUrl: string ='';
  @Input() public settingsRecordUrl: string ='';
  @Input() public deleteRecordUrl: string ='';
  @Input() public listUrl: string='' ;
  @Input() public module: string ='';
  @Input() public rowData:any[]=[];
  @Input() public nuovoLabel: string ='';
  @Input() public listParams: any | undefined;

  
  @ViewChild('maintable') maintable:any;
  @ViewChild('filter') filter!: ElementRef;

  dataList:any=[];
  cols:any[]=[];
  loading:boolean = true;

  form = new FormGroup({});
  model: any = {};
  options: FormlyFormOptions = {};
  fields: FormlyFieldConfig[] = [];
  matchModeOptions: SelectItem[]=[];
  matchMode:any=null;
  hideFilter:boolean = true;
  noFilter:boolean = false;
  
  
  constructor(
    private filterService: FilterService,
    private apiService: ApiService,
    public lang : LanguageService,
    public globalService : GlobalService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService, 
    public router: Router,
  ) { }

  ngOnInit(): void {  
    this.matchModeOptions = [
      { label: this.lang.el('Inizia con'), value: FilterMatchMode.STARTS_WITH },
      { label: this.lang.el('Contiene'), value: FilterMatchMode.CONTAINS }
    ];
    this.matchMode=FilterMatchMode.CONTAINS;
    
    if(!this.nuovoLabel){
      this.nuovoLabel='Nuovo';
    }
  

    this.globalService.configModules.forEach((m:any)=>{
      if(m.name==this.module){
        this.cols=m.colsList;

        this.noFilter=true;
        if(this.cols.filter((x)=>x.filter==true).length>0){
          this.noFilter=false;
        }
      }
    });


    this.apiService.post(this.listUrl,this.listParams).subscribe(data2 => {
      let cd=this.cols.filter((x)=>x.type=='date');
      data2.Result.forEach((r:any)=>{
        cd.forEach((c:any)=>{  
          if(r[c.field]){
            r[c.field]= new Date(r[c.field]);
          }
        });
      });
      this.dataList=data2.Result;
      this.loading = false;
    });

  }
  
  onGlobalFilter(table: Table, event: Event) {
      table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }
  
  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }
  
  clear(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  nuovoRecord(){
    this.router.navigateByUrl(this.newRecordUrl);
  }

  edit(record:any){
    let ef=this.cols.filter((x)=>x.type=='edit');
    if((ef)&&(ef.length>0)){
      this.router.navigateByUrl(this.editRecordUrl+record[ef[0].field]);
    }
   
  }

  delete(record:any){
    this.confirmationService.confirm({
        message: 'Si conferma la cancellazione del record?',
        header: 'Conferma',
        closeOnEscape: true,
        icon: 'pi pi-exclamation-triangle',
        rejectLabel:'Annulla',
        acceptLabel:'Conferma',
        accept: () => {
      
          this.apiService.post(this.deleteRecordUrl,{id:record.id}).subscribe(data2 => {
            this.messageService.add({ severity: 'warning', summary: 'Eliminato', detail: 'Record cancellato' });
            this.dataList = this.dataList.filter((item:any) => item.id !== record.id);
          });
          
        },
        reject: () => {
           
        },
    });
 
  }

  settings(record:any){
    this.router.navigateByUrl(this.settingsRecordUrl+record.id);
  }

}


